/*
*   Sorts the array of flattened variants of a dish in the specified category recursively (inspired to Radix sort):
* 
*   - Sorts Asc level flattenedVariants.last by `pos` key.
*   - Sorts Asc level flattenedVariants.secondLast by `pos` key.
*   - Sorts Asc level flattenedVariants.thirdLast by `pos` key.
*   - And so on. Based on the assumption that `.sort()` is a stable sorting algorithm. 
*
*    @parameter{flattenedVariants: [[String]]}: An array whose elements are complete paths from root to a leaf
*    @parameter{dishesInCategory: [String: Dish]}: An hash table of all the dishes in the category the dishes belong to.
*
*
*    @returns{[[String]]}: The sorted array by `pos` key of all the paths `flattenedVariants`.
*/
export const sortFlattenedVariants = (flattenedVariants, dishesInCategory) => {

    if (!flattenedVariants) {
        console.warn(`In function const sortFlattenedVariants = (flattenedVariants, dishesInCategory), parameter ${flattenedVariants} is null or undefined`)
    } else {
        const maxDepth = flattenedVariants.reduce((currentMax, nextPath) => {
            return Math.max(currentMax, nextPath.length)
        }, -1) 
    
        var t = transposeMatrix(flattenedVariants)
    
        for(var i=0; i < t.length; i++) {
            
        }
        
    }
}


function transposeMatrix(matrix) {
    const rows = matrix.length;
    const cols = matrix[0].length;

    // Create an empty transposed matrix
    const transposed = [];
    for (let j = 0; j < cols; j++) {
        transposed[j] = [];
    }

    // Fill the transposed matrix
    for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols; j++) {
            transposed[j][i] = matrix[i][j];
        }
    }

    return transposed;
}